import { render } from "./warehousingGoods.vue?vue&type=template&id=1e2d2c3f"
import script from "./warehousingGoods.vue?vue&type=script&lang=js"
export * from "./warehousingGoods.vue?vue&type=script&lang=js"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__